import React, { useState, useMemo } from "react";
import * as RC from "../style/kunder-style";
import avtalat from "../../assets/logos-customers/avtalat-logo25.svg";
import avtalatClr from "../../assets/logos-customers/avtalat-logo25_clr.svg";
import coop from "../../assets/logos-customers/coop_logo25.svg";
import coopColor from "../../assets/logos-customers/coop_logo25_color.svg";
import hrlegal from "../../assets/logos-customers/hrlegal_logo25.svg";
import hrlegalClr from "../../assets/logos-customers/hrlegal_logo25_clr.svg";
import hn from "../../assets/logos-customers/hn_logo25.svg";
import hnClr from "../../assets/logos-customers/hn_logo25_clr.svg";
import manpower from "../../assets/logos-customers/manpower-logo25.svg";
import manpowerClr from "../../assets/logos-customers/manpower-logo25_clr.svg";
import skandia from "../../assets/logos-customers/skandia_logo25.svg";
import skandiaColor from "../../assets/logos-customers/skandia_logo25_color.svg";
import ving from "../../assets/logos-customers/ving_primarylogo25.svg";
import vingColor from "../../assets/logos-customers/ving_primarylogo25_color.svg";
import vfs from "../../assets/logos-customers/vfs-logo25.svg";
import vfsClr from "../../assets/logos-customers/vfs-logo25_clr.svg";

export const RecCustomer: React.FC = () => {
	const [isHovering, setIsHovering] = useState(false);

	const isTouchDevice = useMemo(() => window.matchMedia("(hover: none)").matches, []);

	const handleTouchStart = () => {
	  if (!isTouchDevice) return; // Säkerställ att detta bara körs på mobil/padda
  
	  setIsHovering(true);
	  
	  // Dölj hjärtat efter 0.3 sekunder
	  setTimeout(() => {
		setIsHovering(false);
	  }, 300);
	};

	return (
		<>
			<RC.CustomerTopContainer />
			<RC.CustomerContainer>
				<RC.ServicesHeadContainer>
					<RC.CasesH1>Våra kunder</RC.CasesH1>
				</RC.ServicesHeadContainer>

				<RC.LogoContainer>
					<RC.CustomCursor isHovering={isHovering} />
					<RC.LogoBox
						$span={1}
						onMouseEnter={() => !isTouchDevice && setIsHovering(true)}
						onMouseLeave={() => !isTouchDevice && setIsHovering(false)}
						onTouchStart={handleTouchStart}>
						<RC.CustomerLogo
							defaultSrc={ving}
							hoverSrc={vingColor}
							alt="Ving logotyp"
						/>
					</RC.LogoBox>

					<RC.LogoBox
						$span={1}
						onMouseEnter={() => !isTouchDevice && setIsHovering(true)}
						onMouseLeave={() => !isTouchDevice && setIsHovering(false)}
						onTouchStart={handleTouchStart}>
						<RC.CustomerLogo
							defaultSrc={coop}
							hoverSrc={coopColor}
							alt="Coop logotyp"
						/>
					</RC.LogoBox>

					<RC.LogoBox
						$span={1}
						onMouseEnter={() => !isTouchDevice && setIsHovering(true)}
						onMouseLeave={() => !isTouchDevice && setIsHovering(false)}
						onTouchStart={handleTouchStart}>
						<RC.CustomerLogo
							defaultSrc={skandia}
							hoverSrc={skandiaColor}
							alt="Skandia logotyp"
						/>
					</RC.LogoBox>

					<RC.LogoBox
						$span={2}
						onMouseEnter={() => !isTouchDevice && setIsHovering(true)}
						onMouseLeave={() => !isTouchDevice && setIsHovering(false)}
						onTouchStart={handleTouchStart}>
						<RC.CustomerLogo
							defaultSrc={vfs}
							hoverSrc={vfsClr}
							alt="Volkswagen Financial Services logotyp"
						/>
					</RC.LogoBox>

					<RC.LogoBox
						$span={1}
						onMouseEnter={() => !isTouchDevice && setIsHovering(true)}
						onMouseLeave={() => !isTouchDevice && setIsHovering(false)}
						onTouchStart={handleTouchStart}>
						<RC.CustomerLogo
							defaultSrc={hn}
							hoverSrc={hnClr}
							alt="Haninge Naprapat AB logotyp"
						/>
					</RC.LogoBox>

					<RC.LogoBox
						$span={1}
						onMouseEnter={() => !isTouchDevice && setIsHovering(true)}
						onMouseLeave={() => !isTouchDevice && setIsHovering(false)}
						onTouchStart={handleTouchStart}>
						<RC.CustomerLogo
							defaultSrc={manpower}
							hoverSrc={manpowerClr}
							alt="Manpower logotyp"
						/>
					</RC.LogoBox>

					<RC.LogoBox
						$span={1}
						onMouseEnter={() => !isTouchDevice && setIsHovering(true)}
						onMouseLeave={() => !isTouchDevice && setIsHovering(false)}
						onTouchStart={handleTouchStart}>
						<RC.CustomerLogo
							defaultSrc={avtalat}
							hoverSrc={avtalatClr}
							alt="Avtalat logotyp"
						/>
					</RC.LogoBox>

					<RC.LogoBox
						$span={1}
						onMouseEnter={() => !isTouchDevice && setIsHovering(true)}
						onMouseLeave={() => !isTouchDevice && setIsHovering(false)}
						onTouchStart={handleTouchStart}>
						<RC.CustomerLogo
							defaultSrc={hrlegal}
							hoverSrc={hrlegalClr}
							alt="Hr Legal logotyp"
						/>
					</RC.LogoBox>
				</RC.LogoContainer>
			</RC.CustomerContainer>
		</>
	);
};
